export const translations = {
  lv: {
    title: 'Kalkulators',
    pvn: 'PVN',
    vat: 'PVN',
    country: 'Valsts',
    calcType: 'Aprēķina veids',
    sumWithoutPVN: 'Summa bez PVN',
    sumWithPVN: 'Summa ar PVN',
    pvnRate: 'PVN likme',
    other: 'Cits',
    showExact: 'Rādīt precīzas vērtības',
    result: 'Rezultāts',
    netSum: 'Neto summa',
    grossSum: 'Bruto summa',
    taxAmount: 'Nodokļa summa',
    rounding: 'Noapaļošana',
    roundingWarning: 'Noapaļošanas brīdinājums',
    whyHappens: 'Kāpēc tā notiek?',
    exact: 'Precīzi',
    latvia: 'Latvija',
    lithuania: 'Lietuva',
    estonia: 'Igaunija',
    addPVN: 'Pievienot PVN',
    extractPVN: 'Izvilkt PVN',
    showTotal: 'Kopējā summa',
    showEach: 'Katrs rezultāts atsevišķi',
    row: 'Rinda',
    total: 'Kopā',
    roundingExplain1: 'Ja PVN tiek aprēķināts no noapaļotās bezPVN cenas',
    roundingExplain2: 'rezultāts būs',
    roundingExplain3: 'nevis',
    whyExplain1: 'PVN tiek aprēķināts no cenas bez PVN. Kad cena ar PVN ir',
    whyExplain2: 'precīzā cena bez PVN ir',
    whyExplain3: 'Noapaļojot līdz 2 cipariem',
    whyExplain4: 'un aprēķinot PVN no šīs summas:',
    whyExplain5: 'Abas atbildes ir matemātiski pareizas. Cena bez PVN',
    whyExplain6: 'ir jāuzskata par noapaļotu vērtību.',
    copyResult: 'Kopēt rezultātu',
    copied: 'Nokopēts!',
    // SEO Content - optimized for Google ranking
    seoTitle1: 'Kas ir PVN kalkulators?',
    seoText1: 'PVN kalkulators ir bezmaksas tiešsaistes rīks, kas ļauj ātri un precīzi aprēķināt pievienotās vērtības nodokli (PVN) Latvijā. Tas ir īpaši noderīgs uzņēmējiem, grāmatvežiem, individuālajiem komersantiem un ikvienam, kam nepieciešams veikt PVN aprēķinus 2025. gadā. Kalkulators atbalsta visas Latvijas PVN likmes: 21%, 12% un 5%.',
    seoTitle2: 'Kā aprēķināt PVN 21% Latvijā?',
    seoText2: 'Lai aprēķinātu PVN 21% Latvijā, summu bez PVN reizina ar 0.21 un pieskaita pamatvērtībai. Piemēram: 100 EUR × 1.21 = 121 EUR ar PVN. Lai izvilktu PVN no summas ar PVN, to dala ar 1.21. PVN kalkulators šos aprēķinus veic automātiski un bez kļūdām.',
    seoTitle3: 'PVN likmes Latvijā 2025',
    seoText3: 'Latvijā 2025. gadā ir spēkā trīs PVN likmes: standarta likme 21% (vairumam preču un pakalpojumu), samazinātā likme 12% (noteiktām precēm), un samazinātā likme 5% (zālēm, grāmatām, periodiskajiem izdevumiem). Mūsu kalkulators atbalsta visas šīs likmes.',
    seoTitle4: 'PVN aprēķina piemērs',
    seoText4: 'Piemērs ar 21% PVN: ja preces neto cena ir 100 EUR, tad PVN summa = 100 × 0.21 = 21 EUR. Kopējā bruto summa ar PVN = 100 + 21 = 121 EUR. Reversais aprēķins: no 121 EUR ar PVN izvilkt PVN = 121 / 1.21 = 100 EUR bez PVN.',
    seoTitle5: 'Biežāk uzdotie jautājumi par PVN',
    seoText5: 'Vai kalkulators ir bezmaksas?\nJā, pilnīgi bezmaksas un bez reģistrācijas.\n\nVai tas darbojas mobilajā?\nJā, pilnībā adaptīvs dizains.\n\nVai var aprēķināt vairākas summas?\nJā, līdz 10 summām vienlaicīgi.'
  },
  en: {
    title: 'Calculator',
    pvn: 'VAT',
    vat: 'VAT',
    country: 'Country',
    calcType: 'Calculation type',
    sumWithoutPVN: 'Sum without VAT',
    sumWithPVN: 'Sum with VAT',
    pvnRate: 'VAT rate',
    other: 'Other',
    showExact: 'Show exact values',
    result: 'Result',
    netSum: 'Net sum',
    grossSum: 'Gross sum',
    taxAmount: 'Tax amount',
    rounding: 'Rounding',
    roundingWarning: 'Rounding warning',
    whyHappens: 'Why does this happen?',
    exact: 'Exact',
    latvia: 'Latvia',
    lithuania: 'Lithuania',
    estonia: 'Estonia',
    addPVN: 'Add VAT',
    extractPVN: 'Extract VAT',
    showTotal: 'Total sum',
    showEach: 'Each result separately',
    row: 'Row',
    total: 'Total',
    roundingExplain1: 'If VAT is calculated from the rounded net price',
    roundingExplain2: 'the result will be',
    roundingExplain3: 'not',
    whyExplain1: 'VAT is calculated from the price without VAT. When the price with VAT is',
    whyExplain2: 'the exact price without VAT is',
    whyExplain3: 'Rounding to 2 digits',
    whyExplain4: 'and calculating VAT from this amount:',
    whyExplain5: 'Both answers are mathematically correct. Price without VAT',
    whyExplain6: 'should be considered a rounded value.',
    copyResult: 'Copy result',
    copied: 'Copied!',
    // SEO Content - optimized for Google ranking
    seoTitle1: 'What is a VAT calculator?',
    seoText1: 'A VAT calculator is a free online tool that allows you to quickly and accurately calculate value added tax (VAT) in Latvia, Lithuania, and Estonia. It is especially useful for entrepreneurs, accountants, sole proprietors, and anyone who needs to make VAT calculations in 2025. The calculator supports all VAT rates: 21%, 12%, and 5%.',
    seoTitle2: 'How to calculate VAT 21% in Latvia?',
    seoText2: 'To calculate 21% VAT in Latvia, multiply the net amount by 0.21 and add it to the base value. Example: 100 EUR × 1.21 = 121 EUR with VAT. To extract VAT from a gross amount, divide by 1.21. The VAT calculator performs these calculations automatically and without errors.',
    seoTitle3: 'VAT rates in Latvia 2025',
    seoText3: 'In Latvia in 2025, there are three VAT rates: standard rate 21% (most goods and services), reduced rate 12% (certain goods), and reduced rate 5% (medicines, books, periodicals). Our calculator supports all these rates.',
    seoTitle4: 'VAT calculation example',
    seoText4: 'Example with 21% VAT: if the net price is 100 EUR, then VAT = 100 × 0.21 = 21 EUR. Total gross amount with VAT = 100 + 21 = 121 EUR. Reverse calculation: from 121 EUR with VAT, extract VAT = 121 / 1.21 = 100 EUR without VAT.',
    seoTitle5: 'Frequently asked questions about VAT',
    seoText5: 'Is the calculator free?\nYes, completely free and no registration required.\n\nDoes it work on mobile?\nYes, fully responsive design.\n\nCan I calculate multiple amounts?\nYes, up to 10 amounts simultaneously.'
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.lv[key] || key;
};
